// extracted by mini-css-extract-plugin
export default {"container":"Comparator_container__3qgJR"};